export const MAX_NAMES_FOR_GHOST_TEXT = 10;
